var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"object-name":"CDS_T_Publicity__c","layout-name":"DetailLayout","default-title":"市民への情報提供履歴","saved-page":"CDS_VF_PublicityDetail","detail-page-name":"CDS_VF_PublicityDetail","list-page":"CDS_VF_PublicityList","every-overwrite-value":_vm.everyOverwriteValue,"init-value":_vm.initValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }